import { cn } from '@air/utils-tailwind';

import { type BoardTemplate } from '~/components/Modals/BoardTemplateModal/types';

export const countBoards = (boards: BoardTemplate[]): number => {
  return boards.reduce((count, board) => {
    return count + 1 + (board.subBoards ? countBoards(board.subBoards) : 0);
  }, 0);
};

const PADDING_CLASSES = ['pl-0', 'pl-4', 'pl-8', 'pl-12', 'pl-16', 'pl-20'];

export const renderBoardTree = (boards: BoardTemplate[], depth = 0) => {
  return boards.map((board) => (
    <div key={`${depth}-${board.title}`} className={cn('py-1', PADDING_CLASSES[depth] ?? 'pl-24')}>
      <div className={cn('text-14 text-grey-12', depth === 0 && 'font-semibold')}>
        {depth > 0 && '└─ '}
        {board.title}
      </div>
      {board.subBoards && board.subBoards.length > 0 && renderBoardTree(board.subBoards, depth + 1)}
    </div>
  ));
};
